import React, { useEffect,useState } from 'react'
import CampaignShowcase from './CampaignShowcase';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import { Swiper, SwiperSlide } from 'swiper/react';

// import './styles.css';

// import required modules
import { Scrollbar,Pagination,EffectFade, Navigation,Autoplay } from 'swiper/modules';
import { CampaignGet } from '../../api/orgService';
import useApi from '../../api/useApi';
import { toast } from 'react-toastify';

const campaignExample = [
  {
    id:4,  
    title: "Fountain Africa Trust in collaboration with Mt. Kenya University and the County Ministry of Health of Bungoma, presents new born care to all mothers with new born babies.",
      category: "health",
      subcategory:"New-boarn health",
      description:
        "Empowering local communities to protect shorelines, preserve livelihoods, and adapt to the changing climate.",
      type: "audio", // can be "image", "video", or "audio"
      // media: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      media: "https://file.fountainafrica.org/wp-content/uploads/2025/10/FOUNTAIN%20AFRIKA%203.MP3",
      link:"/campaign/campaigndetails"
    },        
// {
//   title: "Building Climate Resilience in Coastal Communities Video",
//   category: "Abuse",
//   description:
//     "Empowering local communities to protect shorelines, preserve livelihoods, and adapt to the changing climate.",
//   type: "video", // can be "image", "video", or "audio"
//   media: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//   // media: "http://www.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0058.jpg",
//   link:"/campaign/campaigndetails"
// },

// {
//   title: "Building Climate Resilience in Coastal Communities",
//   category: "Adaptation",
//   description:
//     "Empowering local communities to protect shorelines, preserve livelihoods, and adapt to the changing climate.",
//   type: "image", // can be "image", "video", or "audio"
//   // media: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//   media: "http://www.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0058.jpg",
//   link:"/campaign/campaigndetails"
// }
,
];

function CampaignSection() {

    const [campaignShowcaseData,setCampaignShowCaseData] = useState(campaignExample)    

    const { request: getAllCampaigns, data:campaignData, error:campaignError} = useApi(CampaignGet);
        
      useEffect(() => {
        getAllCampaigns();
             // eslint-disable-next-line
        }, []);
        
        useEffect(()=>{
          if (campaignData?.status===200) {
            setCampaignShowCaseData(campaignData?.data?.results);
          }
        // eslint-disable-next-line
        },[campaignData])
    
      
        // useEffect(()=>{
        //     if(location?.state?.refresh==="org"){
        //       getAllCampaigns();
        //     }
        //   // eslint-disable-next-line
        //   },[location?.state])
      
        useEffect(()=>{
            if(campaignError){
                toast.error(`${JSON.stringify(campaignError?.response?.data,null,2)}`,{position: "top-center"});
          }
        },[campaignError]) 
    
  return (
    <div className="mySwiper">
    <h2 className="section-title">Join Our Campaigns</h2>
     <Swiper
        // scrollbar={{
        // hide: true,
        // }}
        // effect={'fade'}
        // navigation={true}
        // pagination={true}
        // modules={[Navigation,EffectFade,Pagination]}
        modules={[Autoplay, EffectFade]}
        effect="fade"
        spaceBetween={0}
        slidesPerView={1}
        loop
        autoplay={{ delay: 5000 }}
        className="mySwiper"
    >
    { 
       campaignShowcaseData?.map((camp)=>(
        <SwiperSlide>
            <CampaignShowcase campaign={camp}/>
        </SwiperSlide>
        ))
     }
    </Swiper>
    </div>           
  )
}

export default CampaignSection

